module.exports = __webpack_public_path__ + "static/media/mascotaLogin.1f0a8c28.png";